export default "__VITE_ASSET__BykK6rNX__"